export function mealItineraryTimings(meals = []) {
  return meals.map(meal => ({
    time: meal.time || '',
    description: meal.description || `${meal.reservation_status === 'booked' ? 'Confirmed' : 'Provisional'}: ${meal.type.name} is ordered${meal.hotel ? ` at ${meal.hotel.name}` : ''}. ${meal.clients} for Clients${meal.crew > 0 ? ` and ${meal.crew} for Guides` : ''}`,
    reservation_status: meal.reservation_status,
    source: meal.source || 'current',
    entry_key: meal.entry_key,
    fake: true,
  }))
}
